import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ConsultationView from "../views/ConsultationView.vue";
import SignInView from "../views/SignInView.vue";
import ErrorView from "../views/ErrorView.vue";
const AdminHomeView = () => import("../views/AdminHomeView.vue");
const AdminSessionView = () => import("../views/AdminSessionView.vue");
const AdminSlotsEditView = () => import("../views/AdminSlotsEditView.vue");
const AdminMutationsView = () => import("../views/AdminMutationsView.vue");

import { auth } from "../plugins/keycloak";

const router = createRouter({
    // createWebHistory or createWebHashHistory(import.meta.env.BASE_URL), depending on web proxy change also in init keycloak
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "home",
            component: HomeView,
        },
        {
            path: "/consultation",
            name: "consultation",
            component: ConsultationView,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/signin",
            name: "signin",
            component: SignInView,
        },
        {
            path: "/admin",
            name: "admin-home",
            component: AdminHomeView,
            meta: {
                requiresStaff: true,
            },
        },
        {
            path: "/admin/session/:sessionCode/:selectedDate?/:selectedIndex?/:registrationPk?",
            name: "admin-session",
            component: AdminSessionView,
            meta: {
                requiresStaff: true,
            },
        },
        {
            path: "/admin/session/:sessionCode/slots",
            name: "admin-session-slots",
            component: AdminSlotsEditView,
            meta: {
                requiresStaff: true,
            },
        },
        {
            path: "/admin/session/:sessionCode/mutations",
            name: "admin-session-mutations",
            component: AdminMutationsView,
            meta: {
                requiresStaff: true,
            },
        },
        {
            path: "/error/:msg",
            component: ErrorView,
        },
        {
            path: "/:msg(.*)",
            redirect: "/error/404 PageNotFound",
        },
    ],
});

router.beforeEach(async to => {
    if (to.meta && (to.meta.requiresStaff || to.meta.requiresAuth)) {
        if (!auth.isAuthenticated.value) {
            return {
                name: "signin",
                query: {
                    redirectTo: to.fullPath,
                },
            };
        }
        if (to.meta.requiresStaff && !auth.isStaff.value) {
            return "/error/403 Forbidden";
        }
    }
});

export default router;
